import { Tooltip } from "@mui/material";
import classNames from "classnames";
import type { CSSProperties } from "react";

import styles from "./style.module.scss";

interface IRoundBorderChip {
    text: string;
    color: "blue" | "green" | "red" | "yellow" | "orange" | "grey" | string;
    tooltipText?: string;
    onClick?: () => void;
    style?: CSSProperties;
    styleOptions?: { hideDot?: boolean; outlined?: boolean; onlyColorDot?: boolean };
}

/**
 * Chip as used sometimes within autocomplete options with round borders.
 */
const RoundBorderChip = ({
    text,
    color,
    tooltipText,
    onClick,
    style,
    styleOptions = { hideDot: false, outlined: false, onlyColorDot: false },
}: IRoundBorderChip) => {
    const notDefaultColors = !["blue", "red", "yellow", "green", "orange", "grey"].includes(color);

    const personalisedColor = notDefaultColors ? { "--personalised-color": color } : "";

    return (
        <Tooltip title={tooltipText ?? ""}>
            <div
                className={classNames({
                    [styles["rounded-chip"]]: true,
                    [styles["hide-dot"]]: styleOptions?.hideDot,
                    [styles["outlined"]]: styleOptions?.outlined,
                    [styles["color-dot"]]: styleOptions?.onlyColorDot,
                    [styles["custom-color"]]: notDefaultColors,
                    [styles["blue"]]: !notDefaultColors && color === "blue",
                    [styles["green"]]: !notDefaultColors && color === "green",
                    [styles["red"]]: !notDefaultColors && color === "red",
                    [styles["yellow"]]: !notDefaultColors && color === "yellow",
                    [styles["orange"]]: !notDefaultColors && color === "orange",
                    [styles["grey"]]: !notDefaultColors && color === "grey",
                })}
                onClick={onClick}
                style={{ ...style, ...personalisedColor }}
            >
                {text}
            </div>
        </Tooltip>
    );
};

export default RoundBorderChip;
